import { render } from "./DetailBarang.vue?vue&type=template&id=716ef926&scoped=true"
import script from "./DetailBarang.vue?vue&type=script&lang=js"
export * from "./DetailBarang.vue?vue&type=script&lang=js"

import "./DetailBarang.vue?vue&type=style&index=0&id=716ef926&scoped=true&lang=css"
import "./DetailBarang.vue?vue&type=style&index=1&id=716ef926&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\INVENTORY BCK\\inventoryfe_bck\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716ef926"]])

export default __exports__